import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";
import { formatDateRange } from "../lib/constants";

// Custom red marker
const redIcon = new L.DivIcon({
  className: "wm-marker",
  html: `<div style="width:24px;height:24px;background:hsl(3 100% 59%);border:2px solid #000;border-radius:50%;box-shadow:0 0 0 2px hsl(3 100% 59% / 0.4),0 2px 8px rgba(0,0,0,0.6);display:flex;align-items:center;justify-content:center;"><div style="width:8px;height:8px;background:#000;border-radius:50%;"></div></div>`,
  iconSize: [24, 24],
  iconAnchor: [12, 12],
});

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (points.length === 0) return;
    if (points.length === 1) {
      map.setView([points[0].lat, points[0].lng], 6);
      return;
    }
    const bounds = L.latLngBounds(points.map(p => [p.lat, p.lng]));
    map.fitBounds(bounds, { padding: [40, 40] });
  }, [points, map]);
  return null;
}

export default function EventsMap({ events, height = "500px" }) {
  const points = events.filter(e => e.lat && e.lng);
  const center = points[0] ? [points[0].lat, points[0].lng] : [48.5, 10];

  return (
    <div className="border border-border rounded-sm overflow-hidden" style={{ height }}>
      <MapContainer center={center} zoom={5} style={{ height: "100%", width: "100%" }} data-testid="events-map">
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <FitBounds points={points} />
        {points.map((e) => (
          <Marker key={e.event_id} position={[e.lat, e.lng]} icon={redIcon}>
            <Popup>
              <div style={{ minWidth: 200 }}>
                <div style={{ fontFamily: "'Unbounded', sans-serif", fontWeight: 800, fontSize: 14, marginBottom: 4, letterSpacing: "-0.02em" }}>{e.title}</div>
                <div style={{ fontSize: 11, color: "hsl(0 0% 65%)", marginBottom: 6 }}>{e.city}, {e.country}</div>
                <div style={{ fontSize: 11, color: "hsl(3 100% 65%)", marginBottom: 8, fontWeight: 600 }}>{formatDateRange(e.date_start, e.date_end)}</div>
                <Link to={`/events/${e.event_id}`} data-testid={`map-popup-link-${e.event_id}`} style={{ display: "inline-block", padding: "6px 12px", background: "hsl(3 100% 59%)", color: "white", fontSize: 10, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", textDecoration: "none" }}>Dettagli →</Link>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
